import React, { useState } from "react";
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";
const index = ({
  page,
  setpage,
  numberOfPages,
}: {
  page: number;
  setpage: React.Dispatch<React.SetStateAction<number>>;
  numberOfPages: number;
}) => {
  const Pages: JSX.Element[] = [];
  const [start, setstart] = useState(1);
  const [end, setend] = useState(5);

  const RenderPages = () => {
    {
      for (let index = 0; index < numberOfPages; index++) {
        Pages.push(
          <PaginationItem key={index} onClick={() => setpage(index + 1)}>
            <PaginationLink className="cursor-pointer" isActive={page === index + 1}>
              {index + 1}
            </PaginationLink>
          </PaginationItem>
        );
      }
    }
  };
  RenderPages();
  return (
    <Pagination dir="rtl">
      <PaginationContent>
        <PaginationItem
          className={` ${page === 1 && " pointer-events-none opacity-[.5]"}`}
          onClick={() => {
            page > 1 && setpage(page - 1);
            if (page == start) {
              page > 1 && setstart(start - 1);
              page > 1 && setend(end - 1);
            }
          }}
        >
          {" "}
          <PaginationNext className=" cursor-pointer" />
        </PaginationItem>
        {Pages.slice(start - 1, end)}
        <PaginationItem
          className={` ${
            page === numberOfPages && " pointer-events-none opacity-[.5]"
          }`}
          onClick={() => {
            page < numberOfPages && setpage(page + 1);
            if (page == end) {
              page < numberOfPages && setend(end + 1);
              page < numberOfPages && setstart(start + 1);
            }
          }}
        >
          <PaginationPrevious className=" cursor-pointer" />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
};

export default index;
